import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Expertises from "@/pages/Expertises";
import ExpertiseDetail from "@/pages/ExpertiseDetail";
import Approche from "@/pages/Approche";
import Secteurs from "@/pages/Secteurs";
import Observatoire from "@/pages/Observatoire";
import Contact from "@/pages/Contact";
import NewsletterArticle from "@/pages/NewsletterArticle";
import NewsletterArchive from "@/pages/NewsletterArchive";
import AdminReservations from "@/pages/AdminReservations";
import Unsubscribe from "@/pages/Unsubscribe";
import LegalPage from "@/pages/LegalPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/expertises" element={<Expertises />} />
            <Route path="/expertise/:slug" element={<ExpertiseDetail />} />
            <Route path="/approche-gouvernance-projets" element={<Approche />} />
            <Route path="/secteurs" element={<Secteurs />} />
            <Route path="/observatoire" element={<Observatoire />} />
            <Route path="/observatoire/newsletter" element={<NewsletterArchive />} />
            <Route path="/admin/reservations" element={<AdminReservations />} />
            <Route path="/desabonnement" element={<Unsubscribe />} />
            <Route path="/observatoire/:slug" element={<NewsletterArticle />} />
            <Route path="/observatoire/:slug/en" element={<NewsletterArticle key="en" lang="en" />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<LegalPage slug="mentions-legales" />} />
            <Route path="/confidentialite" element={<LegalPage slug="confidentialite" />} />
            <Route path="/cookies" element={<LegalPage slug="cookies" />} />
            <Route path="/cgu" element={<LegalPage slug="cgu" />} />

            {/* Legacy redirects (SEO preservation) */}
            <Route path="/approche" element={<Navigate to="/approche-gouvernance-projets" replace />} />
            <Route path="/publications" element={<Navigate to="/observatoire" replace />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
